// ManageRows.js
const ManageRows = async (rawData, columns, fieldname) => {
    if (!rawData || !Array.isArray(rawData)) return [];
    if (!columns || !Array.isArray(columns)) return [];

    return rawData.map((rowArray) => {
        const fixedRow = {};
        columns.forEach((col, index) => {
            const key = col[fieldname];
            if (key) {
                const val = rowArray[index];
                fixedRow[key] = (val !== null && val !== undefined) ? val : "";
            }
        });
        return fixedRow;
    });
};

export default ManageRows;